module.exports = __webpack_public_path__ + "img/BV.b4b3ddb3.svg";